import React, {Component, PropTypes} from 'react';
import {Tabs, Tab, AppBar, IconButton} from 'material-ui';
import SwipeableViews from 'react-swipeable-views';
import {styleDashboard} from '../components/users/style';
import {Row, Col} from 'react-flexbox-grid';
import {Link} from 'react-router-dom';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import ActionAccountBox from 'material-ui/svg-icons/action/account-box';
import ActionSupervisorAccount from 'material-ui/svg-icons/action/supervisor-account';
import ActionDateRange from 'material-ui/svg-icons/action/date-range';
import ActionNoteAdd from 'material-ui/svg-icons/action/note-add';
import ManageUser from '../components/users/ManageUsers';
import Setting from '../components/users/setting';
import {List} from 'immutable';
import {Alert} from 'antd';

class BtnMenuRight extends Component {
    render() {
        return (
            <div>
                <IconButton containerElement={< Link to="/"/>} title='Đóng'>
                    <NavigationClose color='white' style={styleDashboard.iconAppBarRight}/>
                </IconButton>
            </div>
        );
    }
}

export default class UserDashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slideIndex: 0
        };
    }

    static propTypes = {
        users: PropTypes.array,
        token: PropTypes.string,
        curProjectID: PropTypes.number,
        account: PropTypes.object
    }

    static defaultProps = {
        users: [],
        token: "",
        curProjectID: 0,
        account: {
            meta: {
                projectId: 0,
            }
        }
    }

    handleChange = (value) => {
        this.setState({slideIndex: value});
    };

    render() {
        const {role} = this.props.account.meta.permissions[this.props.curProjectID ? this.props.curProjectID : 63];
        const listRole = List(role);
        const alertRole = <Alert
            message="Lỗi quyền truy cập"
            description="Không có quyền truy cập vào quản lý người dùng"
            type="warning"
            showIcon/>;
        const mangageUser = listRole.indexOf("view_issues") < 0
            ? alertRole
            : <ManageUser {...this.props} />;

        return (
            <div>
                <Tabs
                    onChange={this.handleChange}
                    value={this.state.slideIndex}
                    inkBarStyle={styleDashboard.bgTab}
                    tabItemContainerStyle={styleDashboard.bgItemTab}>
                    <Tab label="Thông tin" buttonStyle={{color: 'darkslategray'}} value={0}
                         icon={<ActionAccountBox color='rgba(0, 0, 0, 0.49)'/>}/>
                    {/*<Tab label="Quản lý" value={1} buttonStyle={{color: 'darkslategray'}}*/}
                         {/*icon={<ActionSupervisorAccount color='rgba(0, 0, 0, 0.49)'/>}/>*/}
                    {/*<Tab label="Thêm" value={2} buttonStyle={{color: 'darkslategray'}}*/}
                         {/*icon={<ActionNoteAdd color='rgba(0, 0, 0, 0.49)'/>}/>*/}
                    {/*<Tab label="Lịch" value={3} buttonStyle={{color: 'darkslategray'}}*/}
                         {/*icon={<ActionDateRange color='rgba(0, 0, 0, 0.49)'/>}/>*/}
                </Tabs>
                <SwipeableViews index={this.state.slideIndex} onChangeIndex={this.handleChange}>
                    <div style={styleDashboard.slide}>
                        <Row center="xs">
                            <Col xs={8}>
                                <Setting account={this.props.account} logout={this.props.logout}/>
                            </Col>
                        </Row>
                    </div>
                    <div style={styleDashboard.slide}>
                        <Row center="xs">
                            <Col xs={8}>
                                {mangageUser}
                            </Col>
                        </Row>
                    </div>
                </SwipeableViews>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/users.js